const API_CONFIG_CARD = {
  responseMetrics: {
    label: 'Response metrics',
    optional: '(optional)',
    help: 'Metrics defined in this field are available through the API key.',
  },
  conversationTranscript: {
    label: 'Conversation transcript',
    help: 'Access to conversation transcripts for the selected agent.',
  },
  clearConfig: {
    label: 'Clear configuration settings',
  },
};

export default API_CONFIG_CARD;
